import { useQuery } from 'react-query';
import { getAccount, getAccounts } from '../sp-firebase/accountFB';
import { getUserDetails } from '../sp-firebase/userFB';

const fetchAccountDataByUser = async () => {
  try {
    const user = sessionStorage.getItem('uid');
    if (user) {
      const userDetails = await getUserDetails(user);
      if (userDetails) {
        const account = await getAccount(userDetails?.accountId);
        return { account };
      }
    }
    return {};
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

export const useUserAccount = (enabled: boolean) => {
  return useQuery('account', fetchAccountDataByUser, { enabled });
};

const fetchAllAccountsData = async () => {
  const accountsData = await getAccounts();
  return accountsData;
};

export const useAllAccounts = (toFetch: boolean) => {
  return useQuery('accounts-list', fetchAllAccountsData, { enabled: toFetch });
};
